import type { ElementProps, OverlayProps as MantineOverlayProps } from '@mantine/core';
import { Overlay as MantineOverlay } from '@mantine/core';

// Overlay is an atomic full-cover primitive: styling escape hatches stay open
// (e.g. Mantine Transition passes an inline style; call sites need className).
// Mantine's OverlayProps carries none of the div's own props (it's polymorphic), so handlers like
// `onClick` have to be intersected back in.
type OverlayProps = MantineOverlayProps & ElementProps<'div'>;

export const Overlay = (props: OverlayProps) => {
  return <MantineOverlay {...props} />;
};
